import { useIntl } from 'react-intl';
import { slate } from '@/lib/colours';
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  LoadingButton,
  Typography,
} from '@/primitives';
import { legalMessages } from './messages';
import { EULA_LINK } from '@/constants/links';

export interface TermsAndConditionsProps {
  loading?: boolean;
  onClickBack: () => void;
  onClickAccept: () => void;
  open: boolean;
}

export function TermsAndConditionsDialog({
  loading,
  onClickAccept,
  onClickBack,
  open,
}: TermsAndConditionsProps) {
  const intl = useIntl();

  return (
    <Dialog
      disablePortal
      open={open}
      PaperProps={{
        sx: {
          width: '90vw',
          maxWidth: '1200px',
          height: '85vh',
        },
      }}
    >
      <DialogTitle component="div">
        <Typography variant="headlinesmall" sx={{ paddingBottom: '16px' }}>
          {legalMessages['legal.termsAndConditions.heading']}
        </Typography>
        <Typography variant="bodymedium" color={slate[500]}>
          {legalMessages['legal.termsAndConditions.subHeading']}
        </Typography>
      </DialogTitle>
      <DialogContent
        sx={{
          overflowY: 'hidden',
          py: 0,
          ['& > embed embed']: { transform: 'scale(1.25)' },
        }}
      >
        <iframe
          src={EULA_LINK + '#toolbar=0'}
          width="100%"
          height="100%"
          style={{ border: 'none' }}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClickBack}>
          {legalMessages['legal.termsAndConditions.backButton']}
        </Button>
        <LoadingButton
          variant="contained"
          loading={loading}
          loadingText={intl.formatMessage(
            legalMessages['legal.termsAndConditions.acceptingButtonText'].props,
          )}
          onClick={onClickAccept}
        >
          {legalMessages['legal.termsAndConditions.acceptButton']}
        </LoadingButton>
      </DialogActions>
    </Dialog>
  );
}
